import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import axios from 'axios'
import { redirectToLogin } from '@/utils/authRedirect'



// 配置axios
// 统一使用相对路径：开发环境走 vue devServer 代理，生产环境走 Nginx 反向代理
axios.defaults.baseURL = ''
axios.defaults.timeout = 5000
axios.defaults.headers.common['Content-Type'] = 'application/json'

// 统一将 token 放在 Authorization 请求头，后端 Sa-Token 已指定 token-name 为 Authorization
axios.defaults.headers.common['Authorization'] = localStorage.getItem('token') || ''

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 获取token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 将定时器设置为全局变量，方便在登出时清理
window.autoLogoutTimer = null;

/**
 * 处理登出逻辑
 * @param {string} message 自定义登出消息
 */
function handleLogout(message = '登录已过期，请重新登录') {
  redirectToLogin(router, { message });
}

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 检查活跃超时时间
    const activeTimeout = response.headers['x-active-timeout'];
    if (activeTimeout) {
      const timeoutSeconds = parseInt(activeTimeout);
      handleActiveTimeout(timeoutSeconds);
    }
    
    return response;
  },
  error => {
    console.error('响应拦截器错误:', error);
    if (error.response) {
      console.error('错误响应:', error.response.data);
      console.error('错误状态码:', error.response.status);
      
      // 如果是401错误（未授权），可能是token过期
      if (error.response.status === 401) {
        // token 已过期或无效，直接登出
        handleLogout();
      }
    }
    return Promise.reject(error);
  }
);

/**
 * 处理活跃超时时间
 * @param {number} timeoutSeconds 剩余活跃时间（秒）
 */
function handleActiveTimeout(timeoutSeconds) {
  // 清除之前的定时器
  if (window.autoLogoutTimer) {
    clearTimeout(window.autoLogoutTimer);
    window.autoLogoutTimer = null;
  }
  
  // 设置自动登出定时器
  if (timeoutSeconds > 0) {
    window.autoLogoutTimer = setTimeout(() => {
      handleLogout('由于6小时内无下单操作，您已被自动登出，请重新登录');
    }, timeoutSeconds * 1000);
  }
}


const app = createApp(App)
const pinia = createPinia()
app.use(pinia)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(ElementPlus, {
  locale: zhCn,
})

app.use(router)
app.config.globalProperties.$axios = axios

app.mount('#app')
